import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=0da296fc&scoped=true&"
import script from "./GiftList.vue?vue&type=script&lang=js&"
export * from "./GiftList.vue?vue&type=script&lang=js&"
import style0 from "./GiftList.vue?vue&type=style&index=0&id=0da296fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da296fc",
  null
  
)

export default component.exports